module.exports = __webpack_public_path__ + "static/img/phone.928d9eab.svg";